const olderThan25YearsCheck = (newVehicle, state) => {
    const stateCheck = ["Michigan", "New Jersey"]?.includes(state);
    const vehicleOwnedCheck = newVehicle?.vehicleOwnedLeasedFinanced === "Owned";
    const yearCheck = new Date().getFullYear() - parseInt(newVehicle?.vehicleYear) >= 25;

    if (stateCheck && vehicleOwnedCheck && yearCheck) return true;
    return false;
}

export const ValidationForm = (newVehicle, vehicles, drivers, state) => {
    // Date Purchased Checks
    if (newVehicle.datePurchased == "")
        return { title: "Oops!", message: 'Please confirm if this vehicle was purchased in the last 12 months.' };
    if (newVehicle.datePurchased == null)
        return { title: "Oops!", message: 'Please confirm when this vehicle was purchased.' };

    // NJ
    if (state == "New Jersey" && newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.vehicleIsCoOwned == "")
        return { title: "Oops!", message: 'Please select if the vehicle is co-owned.' };
    if (state == "New Jersey" && newVehicle.vehicleIsNJ == "")
        return { title: "Oops!", message: 'Please select if the vehicle is registered in New Jersey.' };

    // PA
    if (state == "Pennsylvania" && newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.vehicleIsCoOwned == "")
        return { title: "Oops!", message: 'Please select if the vehicle is co-owned.' };
    if (state == "Pennsylvania" && newVehicle.vehicleIsPA == "")
        return { title: "Oops!", message: 'Please select if the vehicle is registered in Pennsylvania.' };

    // Owned vehicle
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && !newVehicle.vehicleIsCoOwned)
        return { title: "Oops!", message: 'Please select if the vehicle is co-owned.' };
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.garaged == "")
        return { title: "Oops!", message: 'Please select if the vehicle is primarily kept at this address.' };
    if (!olderThan25YearsCheck(newVehicle, state)) {
        if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "")
            return { title: "Oops!", message: 'Please select if the vehicle will have "Other than Collision" coverage.' };
        if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "1" && newVehicle.otherDeductible == "")
            return { title: "Oops!", message: 'Please choose your "Other than Collision" (Comprehensive) deductible.' };
        if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "1" && newVehicle.wantsCollision == "")
            return { title: "Oops!", message: 'Please specify if you choose "Collision" coverage.' };
        if (state == "Michigan" && newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "1" && newVehicle.wantsCollision == "1" && newVehicle.collisionType == "")
            return { title: "Oops!", message: 'Please select a "Collision" type.' };
        if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "1" && newVehicle.wantsCollision == "1" && newVehicle.collisionDeductible == "")
            return { title: "Oops!", message: 'Please select a "Collision" coverage deductible.' };
        if (newVehicle.vehicleOwnedLeasedFinanced == 'Owned' && newVehicle.wantsOtherThanCollision == "1" && newVehicle.rentalCoverage == "")
            return { title: "Oops!", message: 'Please select if rental reimbursement is needed.' };
    }

    // Leased vehicle
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Leased' && !newVehicle.vehicleIsCoLeased)
        return { title: "Oops!", message: 'Please select if the vehicle is co-leased.' };
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Leased' && newVehicle.vehicleLeasingCompany == "")
        return { title: "Oops!", message: 'Please select the name of the leasing company.' };

    // Financed vehicle
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Financed' && !newVehicle.vehicleIsCoOwned)
        return { title: "Oops!", message: 'Please select if the vehicle is co-owned.' };
    if (newVehicle.vehicleOwnedLeasedFinanced == 'Financed' && newVehicle.vehicleFinanceCompany == "")
        return { title: "Oops!", message: 'Please select the name of the financing company.' };

    // Leased/Financed vehicle
    if ((newVehicle.vehicleOwnedLeasedFinanced == 'Leased' || newVehicle.vehicleOwnedLeasedFinanced == 'Financed') && newVehicle.garaged == "")
        return { title: "Oops!", message: 'Please select if the vehicle is primarily kept at this address.' };
    if ((newVehicle.vehicleOwnedLeasedFinanced == 'Leased' || newVehicle.vehicleOwnedLeasedFinanced == 'Financed') && newVehicle.otherDeductible == "")
        return { title: "Oops!", message: 'Please choose your "Other than Collision" (Comprehensive) deductible.' };
    if (state == "Michigan" && (newVehicle.vehicleOwnedLeasedFinanced == 'Leased' || newVehicle.vehicleOwnedLeasedFinanced == 'Financed') && newVehicle.collisionType == "")
        return { title: "Oops!", message: 'Please select a "Collision" type.' };
    if ((newVehicle.vehicleOwnedLeasedFinanced == 'Leased' || newVehicle.vehicleOwnedLeasedFinanced == 'Financed') && newVehicle.collisionDeductible == "")
        return { title: "Oops!", message: 'Please select a "Collision" coverage deductible.' };
    if ((newVehicle.vehicleOwnedLeasedFinanced == 'Leased' || newVehicle.vehicleOwnedLeasedFinanced == 'Financed') && newVehicle.rentalCoverage == "")
        return { title: "Oops!", message: 'Please select if rental reimbursement is needed.' };

    // Applies to all
    if (newVehicle.vehicleRegistrant == "")
        return { title: "Oops!", message: 'Please select whose name in which this vehicle is registered, or is going to be registered.' };
    if (newVehicle.vehicleUse == "")
        return { title: "Oops!", message: 'Please select how this vehicle will be used.' };
    if (newVehicle.vehicleCustomization == "")
        return { title: "Oops!", message: 'Please select if the vehicle has any modifications or customizations.' };
    if (newVehicle.vehicleCommercial == "")
        return { title: "Oops!", message: 'Please select if this is a commercial vehicle.' };
    if (newVehicle.vehicleCommercialPurposes == "")
        return { title: "Oops!", message: 'Please select if this vehicle is used for commercial purposes.' };
    if (newVehicle.leasedRentToOthers == "")
        return { title: "Oops!", message: 'Please select if this vehicle is leased or rented to other.' };
    if (newVehicle.vehiclePlowSnow == "")
        return { title: "Oops!", message: 'Please select if this vehicle is used to plow snow for compensation.' };
    if (newVehicle.drivenExistingDriver == "")
        return { title: "Oops!", message: 'Please select if this vehicle will be driven by an existing driver on your policy.' };

    // Driver Assignment
    if (newVehicle.componentTracker == "VehicleDriverAssignment") {
        for (let i = 0; i < vehicles.length; i++) {
            // Other Driver Missing Name
            if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverName == "" || vehicles[i]?.driverName == undefined)) {
                return {
                    title: "Oops!", message: `Please provide the other driver's first and last name for 
                    ${"vehicleYear" in vehicles[i] ?
                            vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                            vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`
                };
            }
            // Other Driver Missing DOB
            if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverDOB == "" || vehicles[i]?.driverDOB == undefined)) {
                return {
                    title: "Oops!", message: `Please provide the other driver's DOB for 
                    ${"vehicleYear" in vehicles[i] ?
                            vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                            vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`
                };
            }
            // Other Driver Missing DLN
            if (vehicles[i]?.otherDriverSelected == "Yes" && (vehicles[i]?.driverDLN == "" || vehicles[i]?.driverDLN == undefined)) {
                return {
                    title: "Oops!", message: `Please provide the other driver's license number for 
                                ${"vehicleYear" in vehicles[i] ?
                            vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                            vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`
                };
            }
            // No driver selected for this vehicle
            if (!("driverName" in vehicles[i]) || vehicles[i]?.driverName == '' || vehicles[i]?.driverName == undefined) {
                return {
                    title: "Oops!", message: `Please provide a driver for 
                    ${"vehicleYear" in vehicles[i] ?
                            vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                            vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`
                };
            }
            // Missing Primary/Occasional vehicle selection for vehicles > drivers
            if (vehicles?.length > drivers?.length && vehicles[i]?.driverName != "" && vehicles[i]?.otherDriverSelected != "Yes" && (vehicles[i]?.vehicleType == "" || vehicles[i]?.vehicleType == undefined)) {
                return {
                    title: "Oops!", message: `Please determine if this driver is the primary or occasional driver for 
                                ${"vehicleYear" in vehicles[i] ?
                            vehicles[i]?.vehicleYear + " " + vehicles[i]?.vehicleMake + " " + vehicles[i]?.vehicleModel :
                            vehicles[i]?.Year + " " + vehicles[i]?.Make + " " + vehicles[i]?.Model}.`
                };
            }
        }

        // More vehicles than drivers on policy
        if (vehicles.length > drivers.length) {
            var count = 0

            // Check that each driver is a primary on any vehicle
            for (var i = 0; i < drivers.length; i++) {
                if (vehicles.some((v) => v.driverName == drivers[i]?.fullName && v?.vehicleType == "Primary")) {
                    count += 1;
                }
            }

            // Not all drivers were assigned as a primary driver
            if (count != drivers.length) {
                return {
                    title: "Oops!", message: 'You must select one vehicle as a primary vehicle for each driver to proceed.'
                };
            }
        }
    }
}